module.exports = __webpack_public_path__ + "img/4_48.407553e6.png";